<template>
  <div class="page-container md-layout-column">

    <md-datepicker v-model="dateLogs" @md-closed="getLogsByDate" :md-model-type="String">
      <label>Дата</label>
    </md-datepicker>

    <md-content>
      <md-field>
        <label for="event_type">Событие</label>
        <md-select v-model="eventType" name="event_type" id="event_type" required>
          <md-option value="Auth">Авторизация в приложении</md-option>
          <md-option value="SetStatus">Установили статус заказа</md-option>
          <md-option value="ShiftOrder">Перенос заказа</md-option>
          <md-option value="CreateUser">Создание пользователя</md-option>
          <md-option value="RemoveUser">Удаление пользователя</md-option>
        </md-select>
      </md-field>

      <md-table v-if="eventType === 'Auth'">
        <md-table-row>
          <md-table-head>Время</md-table-head>
          <md-table-head>Пользователь</md-table-head>
        </md-table-row>

        <md-table-row v-for="log in AuthEvents">
          <md-table-cell>{{parseTime(log.time)}}</md-table-cell>
          <md-table-cell>{{log.user.name}}</md-table-cell>
        </md-table-row>
      </md-table>

      <md-table v-if="eventType === 'SetStatus'">
        <md-table-row>
          <md-table-head>Время</md-table-head>
          <md-table-head>Пользователь</md-table-head>
          <md-table-head>№ заказа</md-table-head>
          <md-table-head>Установленный статус</md-table-head>
          <md-table-head>Тип оплаты</md-table-head>
          <md-table-head>Фактическая дата доставки</md-table-head>
          <md-table-head>Тип отказа</md-table-head>
          <md-table-head>Причина отказа</md-table-head>
          <md-table-head>Позиции заказа</md-table-head>
          <md-table-head>Ошибка (если есть то статус не был установлен)</md-table-head>
        </md-table-row>

        <md-table-row v-for="log in SetStatusEvents">
          <md-table-cell>{{parseTime(log.time)}}</md-table-cell>
          <md-table-cell>{{log.user.name}}</md-table-cell>
          <md-table-cell>{{log.order_id}}</md-table-cell>
          <md-table-cell>{{statusName(log.event_type)}}</md-table-cell>
          <md-table-cell>{{log.meta.payment_type}}</md-table-cell>
          <md-table-cell>{{log.meta.date_fact_delivery}}</md-table-cell>
          <md-table-cell>{{log.meta.deny_type}}</md-table-cell>
          <md-table-cell>{{log.meta.deny_reason_id}}</md-table-cell>
          <md-table-cell>// TODO</md-table-cell>
          <md-table-cell>{{log.meta.error}}</md-table-cell>
        </md-table-row>
      </md-table>

      <md-table v-if="eventType === 'ShiftOrder'">
        <md-table-row>
          <md-table-head>Время</md-table-head>
          <md-table-head>Пользователь</md-table-head>
          <md-table-head>№ заказа</md-table-head>
          <md-table-head>Тип переноса</md-table-head>
          <md-table-head>Причина недозвона</md-table-head>
          <md-table-head>Дата переноса</md-table-head>
          <md-table-head>Интервал</md-table-head>
          <md-table-head>Ошибка (если есть то статус не был установлен)</md-table-head>
        </md-table-row>

        <md-table-row v-for="log in ShiftOrderEvents">
          <md-table-cell>{{parseTime(log.time)}}</md-table-cell>
          <md-table-cell>{{log.user.name}}</md-table-cell>
          <md-table-cell>{{log.order_id}}</md-table-cell>
          <md-table-cell>{{log.meta.shift_type}}</md-table-cell>
          <md-table-cell>{{log.meta.reason_call_fail}}</md-table-cell>
          <md-table-cell>{{log.meta.date_shift}}</md-table-cell>
          <md-table-cell>{{log.meta.date_shift_interval}}</md-table-cell>
          <md-table-cell>{{log.meta.error}}</md-table-cell>
        </md-table-row>
      </md-table>

      <md-table v-if="eventType === 'CreateUser'">
        <md-table-row>
          <md-table-head>Время</md-table-head>
          <md-table-head>Пользователь</md-table-head>
          <md-table-head>Созданный пользователь</md-table-head>
          <md-table-head>Ошибка</md-table-head>
        </md-table-row>

        <md-table-row v-for="log in CreateUserEvents">
          <md-table-cell>{{parseTime(log.time)}}</md-table-cell>
          <md-table-cell>{{log.user.name}}</md-table-cell>
          <md-table-cell>{{log.meta.create_id}}</md-table-cell>
          <md-table-cell>{{log.meta.error}}</md-table-cell>
        </md-table-row>
      </md-table>

      <md-table v-if="eventType === 'RemoveUser'">
        <md-table-row>
          <md-table-head>Время</md-table-head>
          <md-table-head>Пользователь</md-table-head>
          <md-table-head>Удаленный пользователь</md-table-head>
          <md-table-head>Ошибка</md-table-head>
        </md-table-row>

        <md-table-row v-for="log in RemoveUserEvents">
          <md-table-cell>{{parseTime(log.time)}}</md-table-cell>
          <md-table-cell>{{log.user.name}}</md-table-cell>
          <md-table-cell>{{log.meta.remove_id}}</md-table-cell>
          <md-table-cell>{{log.meta.error}}</md-table-cell>
        </md-table-row>
      </md-table>

      <md-button class="md-raised md-primary" v-on:click="back">Назад</md-button>
    </md-content>
  </div>
</template>

<script>
  export default {
    name: "Logs",
    data() {
      return {
        eventType: '',
        logs: null,
        dateLogs: '',
      }
    },
    mounted() {
      this.dateLogs = new Date().toISOString().substring(0, 10);
      this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
        event: 'getAllLogsByDate',
        date: this.dateLogs,
      }));
      this.$material.locale.firstDayOfAWeek = 1
    },
    methods: {
      back() {
        this.$router.push({path: '/'});
      },
      statusName(statusEvent) {
        if (statusEvent === 'SetDoneStatus') return 'Полностью выполнен';
        if (statusEvent === 'SetDonePartStatus') return 'Частично выполнен';
        if (statusEvent === 'SetDeniedStatus') return 'Отказ';

        return ``
      },
      parseTime(time) {
        let date = new Date(time);
        let minutes = date.getMinutes();
        minutes = minutes < 10 ? '0'+minutes : minutes;
        return date.getHours() + ":" + minutes
      },
      getLogsByDate() {
        let app = this;
        setTimeout(function () {
          // почемуто v-model="dateLogs" срабатывает ПОСЛЕ метода и отлетает старое значение console.log(app.dateLogs), поэтому тут этот сет таймаут
          app.$store.getters.getWSConnectState.ws.send(JSON.stringify({
            event: 'getAllLogsByDate',
            date: app.dateLogs,
          }));
        });
      },
    },
    computed: {
      SetStatusEvents() {
        return this.$store.getters.getLogsByTypes(['SetDoneStatus', 'SetDonePartStatus', 'SetDeniedStatus']);
      },
      ShiftOrderEvents() {
        return this.$store.getters.getLogsByTypes(['ShiftOrder']);
      },
      CreateUserEvents() {
        return this.$store.getters.getLogsByTypes(['CreateUser']);
      },
      RemoveUserEvents() {
        return this.$store.getters.getLogsByTypes(['RemoveUser']);
      },
      AuthEvents() {
        return this.$store.getters.getLogsByTypes(['Auth']);
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logs.vue